export default {
  normal: '400',
  medium: '500',
  semibold: '600',
  extrabold: '800',
};
